import {
  publishEventParameter,
  publishGa4Events,
} from '@porterin/component-library/src/ts-utils/analytics/react-ga/EventTracker';
import { getLocaleCookie } from '@porterin/booking-flow/src/order-review/view/helpers/CookieHelper';
import Image from 'next/image';
import React from 'react';

import { useCitySelectedContext } from '../../contexts/city-context/CityContext';
import {
  useModalContext,
  openFareEstimateModal,
} from '../../contexts/modal-context/ModalContext';
import {
  ImageTitleDesc,
  FareEstimateContent,
  CityService,
} from '../../shared/cities/domain/entities/CitiesEntity';
import { GA_GET_ESTIMATE_ACTION, GA_GET_ESTIMATE_ACTION_V2 } from '../../shared/core/constants/GAEventsConstants';

import styles from '../styles/common/EstimateCard.module.scss';

interface EstimateCardCmpProps {
  category_cards_data: CityService[];
  fare_estimate_form_content: unknown;
  fare_estimate_action: ImageTitleDesc;
  modal_content: FareEstimateContent;
}

function EstimateCardCmp({
  category_cards_data,
  fare_estimate_form_content,
  fare_estimate_action,
  modal_content,
}: EstimateCardCmpProps): React.ReactElement {
  const modalContext = useModalContext();
  const citySelectedContext = useCitySelectedContext();

  const handleClick = (): void => {
    modalContext.toggleModal(
      openFareEstimateModal(category_cards_data, fare_estimate_form_content, modal_content),
    );
    publishEventParameter(GA_GET_ESTIMATE_ACTION, {
      category: citySelectedContext.category,
      language_selected: getLocaleCookie(),
    });
    publishGa4Events(citySelectedContext.category, GA_GET_ESTIMATE_ACTION_V2);
  };

  return (
    <div className={styles['estimate-card']} onClick={handleClick}>
      <div>
        <div className={styles['estimate-text']}>
          {fare_estimate_action.title}
        </div>
        <div className={styles['estimate-subtext']}>
          {fare_estimate_action.desc}
        </div>
      </div>
      <div className={styles['icon-bg']}>
        <Image
          src={fare_estimate_action.icon.path}
          width={20}
          height={15}
          alt={fare_estimate_action.icon.alt_text}
          quality={100}
        />
      </div>
    </div>
  );
}

export default EstimateCardCmp;
